import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid, parseOptions} from '../question-helper';
import {GlobalQuestionService} from '../../services/global-question.service';
import {ModalService} from '../../services/modal.service';

declare const $: any;

@Component({
    selector: 'app-question-checkbox-image',
    templateUrl: './question-checkbox-image.component.html',
    styleUrls: ['./question-checkbox-image.component.scss'],
    standalone: false
})
export class QuestionCheckboxImageComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() isEmergency = false;
  @Output() questionAnswer = new EventEmitter<any>();
  @Output() openModal = new EventEmitter<any>();

  items = [];
  uniqueControlName = `checkbox-image-name-${newGuid()}`;
  selectedItem: any;
  initialAnswer = '';

  constructor(
    private questionService: GlobalQuestionService,
    private modalService: ModalService
  ) {
  }

  ngOnInit(): void {
    this.modalService.requestEmergencyServiceObservable
      .subscribe(x => {
        if (x) {
          const index = this.items?.findIndex(y => y?.answer === x?.answer);
          if (index > -1) {
            this.checkMultiSelect(index, true);
          }
        } else {
          const index = this.items?.findIndex(y => y?.answer === this.selectedItem?.answer);
          if (index > -1) {
            this.checkMultiSelect(index, false);
          }
        }
      });
    this.modalService.cancelEmergencyServiceObservable
      .subscribe(x => {
        if (x) {
          const index = this.items?.findIndex(y => y?.answer === x?.answer);
          if (index > -1) {
            this.checkMultiSelect(index, false);
          }
        } else {
          const index = this.items?.findIndex(y => y?.answer === this.selectedItem?.answer);
          if (index > -1) {
            this.checkMultiSelect(index, true);
          }
        }
      });
    /*this.items = [];
    if (this.question?.options) {
      const options: any[] = parseOptions(this.question?.options);
      if (options?.length) {
        for (const option of options) {
          let answers = [];
          if (this.question?.answer) {
            answers = this.question?.answer?.split('|');
          }

          const item = {
            answer: option?.answer,
            checked: answers?.includes(option?.answer),
            order: option?.order,
            image_url: option?.image_url,
            info_comment: option?.info_comment
          };
          this.items?.push(item);
        }

        if (this.items?.length) {
          this.items?.sort((a, b) => a.answer_order > b.answer_order ? 1 : a.answer_order < b.answer_order ? -1 : 0);
        }
      }
      const options: any[] = parseOptions(this.question.options);
      if (options?.length > 0) {
        options.forEach(option => {
          let checked = '';
          if (this.question?.answer) {
            const selectedOptions = this.question.answer.split('|');
            if (selectedOptions.some(i => i === option?.answer)) {
              checked = 'checked';
            }
          }
          const item = {
            answer: option.answer,
            checked,
            order: option.order,
            image_url: option.image_url,
            info_comment: option.info_comment
          };
          this.items.push(item);
        });
      }

      if (this.items?.length) {
        this.items.sort((a, b) => a.answer_order > b.answer_order ? 1 : a.answer_order < b.answer_order ? -1 : 0);
      }

      if (this.isEmergency) {
        this.watchCancel();
      }

    }*/
  }

  ngAfterViewInit(): void {
    this.questionService.initPopoverCustomize();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;
      if (this.question?.answer) {
        this.initialAnswer = this.question?.answer;
      }
      this.setupOptions();
    }
  }

  setupOptions(): void {
    this.items = [];
    if (this.question?.options) {
      const options: any[] = parseOptions(this.question?.options);
      if (options?.length) {
        for (const option of options) {
          let answers = [];
          if (this.question?.answer) {
            answers = this.question?.answer?.split('|');
          }

          const item = {
            answer: option?.answer,
            checked: answers?.includes(option?.answer),
            order: option?.order,
            image_url: option?.image_url,
            info_comment: option?.info_comment
          };
          this.items?.push(item);
        }

        if (this.items?.length) {
          this.items?.sort((a, b) => a.answer_order > b.answer_order ? 1 : a.answer_order < b.answer_order ? -1 : 0);
        }
      }
    }
  }

  emitOpenModal(type: string, item: any): void {
    this.selectedItem = item;
    this.openModal.emit({type, item});
  }

  checkNonEmergencySelect(index: number): void {
    if (this.readOnly) { return; }
    this.items[index].checked = !this.items[index].checked;
    this.submitAnswer();
  }

  checkMultiSelect(index: number, value: boolean): void {
    if (this.readOnly) { return; }
    this.items[index].checked = value;
    this.submitAnswer();
    /*const selectedOptions = [];
    const checkboxes = document.getElementsByName(`${this.uniqueControlName}`);

    for (const c of checkboxes) {
      const el = c as HTMLInputElement;
      if (el.checked) {
        selectedOptions.push(el.value);
      }
    }
    if (selectedOptions?.length) {
      this.submitAnswer(selectedOptions.join('|'));
    }*/
  }

  /*  watchCancel(): void {
      $(document).on('click', '.checkbox-item', (e: any) => {
        e.preventDefault();

        console.log(e.target);
        const $control = $('.custom-input--categories-claims-cancel');
        const $input = $(e.target);

        if ($input.attr('checked') == 'checked') {
          this.launchCancelModal('#emergency-call-modal-cancel', $control, $input, $input.attr('value'));
        } else {
          this.launchConfirmModal('#emergency-call-modal-confirm', $control, $input, $input.attr('value'));
        }
      });
    }*/

  /*  launchConfirmModal(id: any, $control: any, $input: any, name: any): void {
      $('#modal-confirm-assistance-product').text(' ' + name);

      // launch modal
      $(id).modal({
        keyboard: false,
        backdrop: 'static'
      });

      $('#yes-confirm').off('click').on('click', (e: any) => {
        $input.prop('checked', true);
      });

      this.checkMultiSelect();
    }*/

  /*launchCancelModal(id: any, $control: any, $input: any, name: any): void {
// populate modal assistance type
    $('#modal-assistance-product').text(' ' + name);

    // launch modal
    $(id).modal({
      keyboard: false,
      backdrop: 'static'
    });

    $('#yes-cancel').off('click').on('click', (e: any) => {
      $input.prop('checked', false);
    });

    /!*this.checkMultiSelect();*!/
  }*/

  submitAnswer(): void {
    const answers = [];
    for (const item of this.items) {
      if (item?.checked) {
        answers?.push(item?.answer);
      }
    }
    if (this.question) {
      this.question.answer = answers?.join('|');
      this.questionAnswer.emit(this.question);

      if (this.isEmergency && this.initialAnswer !== this.question?.answer) {
        this.initialAnswer = this.question?.answer;
        this.questionService.saveAnswerOnly(this.question).subscribe();
      }
    } else {
      this.questionAnswer.emit(answers?.join('|'));
    }
  }
}
